export default "__VITE_ASSET__4b6be602__"